(function(){
  function track(name,value){
    if(!name){return;}
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event:name,popa_value:value||null});
  }
  document.addEventListener('click',function(event){
    var tracked=event.target.closest('[data-popa-event]');
    if(tracked){track(tracked.getAttribute('data-popa-event'),tracked.getAttribute('data-popa-value'));}
  });
  var root=document.querySelector('[data-popa-routine]');
  if(!root){return;}
  var results={
    sea:{label:'Your POPA hydration routine',title:'Replenish your everyday ritual.',copy:'Start with the Sea Moss Skincare Set for a simple cleanse, tone, and moisturize routine.',href:'/collections/sea-moss-skincare',cta:'Shop the Sea Moss Routine'},
    rose:{label:'Your POPA soothing routine',title:'Keep your ritual soft and simple.',copy:'Start with the Rosewater Skincare Set, then add the eye mask when your routine needs an extra moment.',href:'/collections/rosewater-skincare',cta:'Shop the Rosewater Routine'},
    turmeric:{label:'Your POPA radiance routine',title:'Build your glow ritual.',copy:'Begin with the Turmeric Skincare Set and add Glow Polish one to two times weekly.',href:'/collections/turmeric-skincare',cta:'Shop the Turmeric Routine'},
    tea:{label:'Your POPA balancing routine',title:'Refresh and rebalance your ritual.',copy:'Begin with the Tea Tree Skincare Set for a straightforward cleanse, tone, and moisturize sequence.',href:'/collections/tea-tree-skincare',cta:'Shop the Tea Tree Routine'}
  };
  root.addEventListener('click',function(event){
    var choice=event.target.closest('[data-routine-choice]');
    if(!choice){return;}
    var key=choice.getAttribute('data-routine-choice');
    var data=results[key];
    root.querySelectorAll('[data-routine-choice]').forEach(function(button){button.setAttribute('aria-pressed',button===choice?'true':'false');});
    root.querySelector('[data-result-label]').textContent=data.label;
    root.querySelector('[data-result-title]').textContent=data.title;
    root.querySelector('[data-result-copy]').textContent=data.copy;
    var link=root.querySelector('[data-result-link]');
    link.href=data.href;
    link.textContent=data.cta;
    link.setAttribute('data-popa-event','routine_shop_click');
    link.setAttribute('data-popa-value',key);
    track('routine_goal_select',key);
    track('routine_result_view',key);
  });
})();
